import { Component } from '@angular/core';

@Component({
  selector: 'app-open13-info-component',
  imports: [],
  templateUrl: './open13-info-component.html',
  styleUrl: './open13-info-component.scss'
})
export class Open13InfoComponent {

}
